/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Work_EmptyInputs */

const vi_station_work_empty = /** @type {(inputs: Station_Work_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hôm nay không còn lịch`)
};

/**

* @param {Station_Work_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_work_empty = /** @type {((inputs?: Station_Work_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Work_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_work_empty(inputs)
});